var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGloben = function SvgGloben(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 20h-.33c.33-1.28.53-2.62.53-4 0-8.82-7.18-16-16-16S0 7.18 0 16c0 1.38.2 2.72.53 4H.2a.2.2 0 0 0-.2.2v11.6c0 .11.09.2.2.2h31.6a.2.2 0 0 0 .2-.2V20.2a.2.2 0 0 0-.2-.2M2 16C2 8.28 8.28 2 16 2s14 6.28 14 14c0 1.39-.23 2.73-.62 4H2.62A13.6 13.6 0 0 1 2 16m9 14v-3h10v3zm19 0h-7v-4.8a.2.2 0 0 0-.2-.2H9.2a.2.2 0 0 0-.2.2V30H2v-8h28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.05 14a2 2 0 1 1-3.999.001A2 2 0 0 1 21.05 14m6 0a2 2 0 1 1-3.999.001A2 2 0 0 1 27.05 14"
  })));
};
export default SvgGloben;